import React, {useState, useEffect} from 'react';
import {useHistory} from "react-router-dom";
import {withTranslation} from 'react-i18next';
import {DataTable} from 'primereact/datatable';
import {Column} from 'primereact/column';
import {Button} from "primereact/button";
import {Dropdown} from "primereact/dropdown";
import {InputText} from "primereact/inputtext";
import {Panel} from "primereact/panel";
import axios from "axios";

const ProjectitemListComponent = (props) => {

  const {t, detailedSearchVisible, view, onDetailedSearchActiveChange} = props;
  const history = useHistory();
  const [projectitems, setProjectitems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalRecords, setTotalRecords] = useState(0);
  const [projectItemStatuses, setProjectItemStatuses] = useState([]);

  const LIST_STORAGE_KEY = 'lastProjectitemListState';
  const DS_STORAGE_KEY = 'lastProjectitemDetailedSearchForm';
  const savedListState = localStorage.getItem(LIST_STORAGE_KEY)
    ? JSON.parse(localStorage.getItem(LIST_STORAGE_KEY))
    : null;
  const savedDetailedForm = localStorage.getItem(DS_STORAGE_KEY)
    ? JSON.parse(localStorage.getItem(DS_STORAGE_KEY))
    : null;
  const [rows, setRows] = useState(
    savedListState?.rows || Number(process.env.REACT_APP_LIST_ROW_DEFAULT)
  );
  const [detailedSearchQuery, setDetailedSearchQuery] = useState(
    savedListState?.detailedSearchQuery ?? ''
  );

  const [dsProjectItemStatus, setDsProjectItemStatus] = useState(savedDetailedForm?.dsProjectItemStatus || null);
  const [dsProjectNumber, setDsProjectNumber] = useState(savedDetailedForm?.dsProjectNumber || null);
  const [dsName, setDsName] = useState(savedDetailedForm?.dsName || null);
  const [dsProjectName, setDsProjectName] = useState(savedDetailedForm?.dsProjectName || null);
  const [dsExternalReference, setDsExternalReference] = useState(savedDetailedForm?.dsExternalReference || null);
  const [dsBarcode, setDsBarcode] = useState(savedDetailedForm?.dsBarcode || null);

  const getCurrentBacklink = () => {
    const currentHash = window.location.hash || '';
    return currentHash.startsWith('#') ? currentHash.substring(1) : currentHash;
  };

  const isDetailedSearchActive = React.useMemo(() => {
    return (detailedSearchQuery || '').toString().trim().length > 0;
  }, [detailedSearchQuery]);
  const [lazyParams, setLazyParams] = useState(() => {
      const savedLazyParams = savedListState?.lazyParams;
      if (savedLazyParams) {
        return {
          ...savedLazyParams,
          first: savedLazyParams.first ?? 0,
          rows: savedLazyParams.rows ?? rows,
          page: savedLazyParams.page ?? 0,
          sortField: savedLazyParams.sortField || 'id',
          sortOrder: typeof savedLazyParams.sortOrder === 'number' ? savedLazyParams.sortOrder : -1,
        };
      }
      return {
        first: 0,
        rows: rows,
        page: 0,
        sortField: 'id',
        sortOrder: -1,
      };
    });

  let loadLazyTimeout = null;
  const loadLazyData = () => {
    setLoading(true);
    if (loadLazyTimeout) {
      clearTimeout(loadLazyTimeout);
    }
    loadLazyTimeout = setTimeout(() => {
      const apiLazyParams = {...lazyParams};
      delete apiLazyParams.filters;
      let query = window.App.transformQueryParams(apiLazyParams)
      let extraQuery = '';
      let finalDetailedQuery = detailedSearchQuery;
      if (props.forcedSearchQuery) {
        finalDetailedQuery = finalDetailedQuery 
          ? finalDetailedQuery + (finalDetailedQuery.endsWith('&') || props.forcedSearchQuery.startsWith('&') ? '' : '&') + props.forcedSearchQuery
          : props.forcedSearchQuery;
      }
      if (finalDetailedQuery) {
        if (!query || query.toString().length === 0) {
          query = '?' + finalDetailedQuery;
        } else if (query.toString().includes('?')) {
          query = query + (query.toString().endsWith('?') || query.toString().endsWith('&') ? '' : '&') + finalDetailedQuery;
        } else {
          query = '?' + query + '&' + finalDetailedQuery;
        }
      }
      if (extraQuery) {
        query += (query.endsWith('?') || query.endsWith('&') ? '' : '&') + extraQuery;
      }
      apiCall('get', '/api/v2/project-item' + query)
        .then(response => {
          setTotalRecords(response.data.data.total_item_count);
          setProjectitems(response.data.data.items)
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        })
    }, Math.random() * 1000 + 250);
  }
  const onPage = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    setLazyParams(_lazyParams);
  }
  const onSort = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    setLazyParams(_lazyParams);
  }
  const pager = {
    layout: 'RowsPerPageDropdown CurrentPageReport PrevPageLink NextPageLink',
    'RowsPerPageDropdown': (options) => {
      const dropdownOptions = [
        {label: Number(process.env.REACT_APP_LIST_ROW_OP1), value: Number(process.env.REACT_APP_LIST_ROW_OP1)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP2), value: Number(process.env.REACT_APP_LIST_ROW_OP2)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP3), value: Number(process.env.REACT_APP_LIST_ROW_OP3)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP4), value: Number(process.env.REACT_APP_LIST_ROW_OP4)},
      ];

      return (
        <>
          {/*<span className="p-mx-1" style={{color: 'var(--text-color)', userSelect: 'none'}}>Tételek egy oldalon: </span>*/}
          <Dropdown value={options.value} options={dropdownOptions} onChange={(e) => setRows(e.target.value)}
                    appendTo={document.body}/>
        </>
      );
    },
    'CurrentPageReport': (options) => {
      return (
        <span style={{color: 'var(--text-color)', userSelect: 'none', width: '120px', textAlign: 'center'}}>
                        {options.first} - {options.last} / {options.totalRecords}
        </span>
      )
    }
  };

  const persistDetailedForm = () => {
    const payload = {
      dsProjectItemStatus,
      dsProjectNumber,
      dsProjectName,
      dsExternalReference,
      dsName,
      dsBarcode,
    };
    localStorage.setItem(DS_STORAGE_KEY, JSON.stringify(payload));
  };

  const clearDetailedFormPersist = () => {
    localStorage.removeItem(DS_STORAGE_KEY);
  };

  const buildDetailedSearchQuery = () => {
    let parts = [];
    if (dsProjectItemStatus) {
      parts.push('search[project_item_status][operator]==&search[project_item_status][value]=' + dsProjectItemStatus);
    }
    if (dsProjectNumber) {
      parts.push('search[project_number][operator]=like&search[project_number][value]=' + dsProjectNumber);
    }
    if (dsProjectName) {
      parts.push('search[project_name][operator]=like&search[project_name][value]=' + dsProjectName);
    }
    if (dsExternalReference) {
      parts.push('search[external_reference][operator]=like&search[external_reference][value]=' + dsExternalReference);
    }
    if (dsName) {
      parts.push('search[name][operator]=like&search[name][value]=' + dsName);
    }
    if (dsBarcode) {
      parts.push('search[production_item_barcode][operator]=like&search[production_item_barcode][value]=' + encodeURIComponent(dsBarcode));
    }

    return parts.filter(Boolean).join('&');
  }

  const doDetailedSearch = () => {
    const q = buildDetailedSearchQuery();
    setDetailedSearchQuery(q);
    setLazyParams((prev) => ({
      ...prev,
      first: 0,
      page: 0,
    }));
  };

  const apiCall = (method, url, data) => {
    return axios({
      method: method,
      url: process.env.REACT_APP_API_HOST + url,
      data,
      params: {},
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
        'App-Network': localStorage.getItem("networkId")
      }
    })
  }

  const actionBodyTemplate = (rowData) => {
    return (
      <React.Fragment>
        <Button icon="pi pi-eye" className=" p-button p-mr-2"
                tooltip={t('view')} tooltipOptions={{position: 'left'}}
                onClick={() => {
                  history.push(
                    '/production/project-item/read/' +
                    rowData.id +
                    '?backlink=' +
                    encodeURIComponent(getCurrentBacklink())
                  )
                }}/>
        {/* {localStorage.getItem('roles').toString().includes('role_') &&
          <Button icon="pi pi-pencil" className="  p-button-warning p-mr-2"
                  tooltip={t('edit')} tooltipOptions={{position: 'left'}}
                  onClick={() => {
                    if(entity === 'project-item') {
                      history.push('/production/project-item/update/' + rowData.id)
                    }
                  }}/>
        }
        {localStorage.getItem('roles').toString().includes('role_') &&
          <Button icon="pi pi-trash" className="p-button-danger"
                  tooltip={t('delete')} tooltipOptions={{position: 'left'}}
                  onClick={() => {
                    if (window.confirm('A törlés megerősítésére van szükség!')) {
                      setLoading(true);
                      apiCall('delete', '/api/v2/project-item/' + rowData.id)
                        .then(response => {
                          window.App.toastShow('success', 'Sikeres törlés!');
                          window.App.setState({rerenderProjectitemList: Math.random()})
                        })
                        .catch(error => {
                          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
                        })
                        .finally(() => {
                          setLoading(false);
                        })
                    }
                  }}
          />
        } */}
      </React.Fragment>
    );
  }

  useEffect(() => {
    localStorage.setItem(LIST_STORAGE_KEY, JSON.stringify({
      rows,
      lazyParams,
      detailedSearchQuery,
      sortField: lazyParams.sortField || 'id',
      sortOrder: typeof lazyParams.sortOrder === 'number' ? lazyParams.sortOrder : -1,
    }));
  }, [rows, lazyParams, detailedSearchQuery]);

  useEffect(() => {
    if (typeof onDetailedSearchActiveChange === 'function') {
      onDetailedSearchActiveChange(isDetailedSearchActive);
    }
  }, [isDetailedSearchActive, onDetailedSearchActiveChange]);

  useEffect(() => {
    setLazyParams((prev) => ({
      ...prev,
      rows: rows
    }));
  }, [rows]);

  useEffect(() => {
    axios({
      method: 'get',
      url: process.env.REACT_APP_API_HOST + "/api/v2/project-item-status",
      params: {},
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
        'App-Network': localStorage.getItem("networkId")
      }
    })
      .then(response => {
        setProjectItemStatuses(Array.isArray(response.data.data.items) ? response.data.data.items : []);
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      });
  }, []);

  useEffect(() => {
    loadLazyData();
  }, [lazyParams, window.App.state.rerenderProjectitemList])

  return (
    <>
      {(detailedSearchVisible  || view === 'search') &&
        <Panel className="p-mb-2" onKeyDown={(e) => {
            if (e.key === 'Enter') {
              e.preventDefault();
              e.stopPropagation();
              doDetailedSearch();
            }
          }}>
          <div className={"p-grid"}>

            <div className={"p-col-12 p-lg-3"}>
              <div className="p-field p-fluid">
                <label>{t('columnStatus2')}</label>
                <Dropdown
                  value={dsProjectItemStatus}
                  options={projectItemStatuses.map(status => ({ label: status.name, value: status.id }))}
                  onChange={(e) => setDsProjectItemStatus(e.value)}
                  showClear
                  placeholder={t('dsSelect')}
                />
              </div>
            </div>

            <div className={"p-col-12 p-lg-3"}>
              <div className="p-field p-fluid">
                <label>{t('projectNumber')}</label>
                <InputText value={dsProjectNumber} onChange={(e) => setDsProjectNumber(e.target.value)} />
              </div>
            </div>

            <div className={"p-col-12 p-lg-3"}>
              <div className="p-field p-fluid">
                <label>{t('columnProjectName')}</label>
                <InputText value={dsProjectName} onChange={(e) => setDsProjectName(e.target.value)} />
              </div>
            </div>

            <div className={"p-col-12 p-lg-3"}>
              <div className="p-field p-fluid">
                <label>{t('columnProjectItem')}</label>
                <InputText value={dsName} onChange={(e) => setDsName(e.target.value)} />
              </div>
            </div>

            <div className={"p-col-12 p-lg-3"}>
              <div className="p-field p-fluid">
                <label>{t('externalReference')}</label>
                <InputText value={dsExternalReference} onChange={(e) => setDsExternalReference(e.target.value)} />
              </div>
            </div>

            <div className={"p-col-12 p-lg-3"}>
              <div className="p-field p-fluid">
                <label>{t('barcode')}</label>
                <InputText value={dsBarcode} onChange={(e) => setDsBarcode(e.target.value)} />
              </div>
            </div>

             <div className={"p-col-12 p-text-right"}>
                <Button
                  type="button"
                  label={t('dsClearCriteria')}
                  icon="pi pi-times"
                  className="p-button-danger p-mr-2"
                  onClick={() => {
                    setDsProjectItemStatus(null);
                    setDsProjectNumber('');
                    setDsProjectName('');
                    setDsExternalReference('');
                    setDsName('');
                    setDsBarcode('');
                    setDetailedSearchQuery('');
                    clearDetailedFormPersist();
                    localStorage.removeItem(LIST_STORAGE_KEY);
                    setLazyParams({
                      first: 0,
                      rows: rows,
                      page: 0,
                      sortField: 'name',
                      sortOrder: 1,
                    });
                  }}
                />
                <Button
                  type="button"
                  label={t('dsSearch')}
                  icon="pi pi-search"
                  className="p-button-primary"
                  onClick={() => {
                    const q = buildDetailedSearchQuery();
                    setDetailedSearchQuery(q);
                    persistDetailedForm();
                    setLazyParams({
                      ...lazyParams,
                      first: 0,
                      page: 0,
                    });
                  }}
                />
              </div>
            </div>
          </Panel>
        }

      <DataTable size={localStorage.getItem('scale')}
                 emptyMessage={t('noResults')}
                 value={projectitems} paginator first={lazyParams.first} totalRecords={totalRecords} onPage={onPage}
                 onSort={onSort} sortField={lazyParams.sortField} sortOrder={lazyParams.sortOrder}
                 loading={loading} lazy
                 paginatorTemplate={pager} rows={rows}
                 autoLayout={true}
                 responsiveLayout="scroll"
                 stripedRows
                 dataKey="id"
      >
        <Column field="project_item_status.name" header={t('columnStatus')} sortable></Column>
        <Column field="project.project_number" header={t('projectNumber')} sortable></Column>
        <Column field="project.name" header={t('columnProjectName')} sortable></Column>
        <Column field="name" header={t('columnProjectItem')} sortable></Column>
        <Column field="external_reference" header={t('externalReference')} sortable></Column>
        <Column header={t('columnQuantity')} body={(rowData) => {
          return (
            <>{rowData?.quantity} {rowData?.unit?.name}</>
          )
        }}></Column>

        <Column body={actionBodyTemplate} className={"p-py-0 p-text-right p-text-nowrap"}></Column>
      </DataTable>
    </>
  )
}
export default withTranslation('common')(ProjectitemListComponent);
